















import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({})
export default class UserComponent extends Vue {
    @Getter('userDisplayData', { namespace: 'user' }) userDisplayData: any;
}
